<template>
  <el-container id="resvGlAdd">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding-left:40px;padding-right:40px">
        <div style="display:flex;justify-content:center;color:#333333">
          <p style="font-size:20px;font-weight:bold;">{{ name }}</p>
        </div>
        <div style="display:flex;align-items:center;margin-top:0px;">
          <p style="width:120px">预约名称</p>
          <el-input v-model="edi_name" :step="1" style="width:20%"></el-input>
        </div>
        <div style="display:flex;align-items:center;margin-top:10px">
          <p style="margin-top:0;width:120px">预约空间</p>
          <el-select v-model="edi_room" ref='select12' @change="change_room"
                     filterable placeholder="全部空间"
                     style="width:20%;">
            <el-option
              v-for="item in li_room"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div style="display:flex;align-items:center;margin-top:10px;">
          <p style="width:120px">预约日期</p>
          <el-date-picker
            v-model="edi_day"
            :clearable="false"
            type="date"
            placeholder="选择日期"
            style="width:20%;">
          </el-date-picker>
        </div>
        <div style="display:flex; align-items: center;margin-top:10px;">
          <p style="width:120px;">预约时间段</p>
          <el-time-select
            placeholder="起始时间"
            style="width:10%"
            v-model="startTime"
            :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '24:00'
                }">
          </el-time-select>
          <p style="margin-left:6px;margin-right:6px"> 至 </p>
          <el-time-select
            placeholder="结束时间"
            style="width:10%"
            v-model="endTime"
            :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '24:00',
                  minTime: startTime
                }">
          </el-time-select>
        </div>
        <div v-if="isAttendNum" style="display:flex;align-items:center;margin-top:10px;">
          <p style="width:120px">人数</p>
          <el-input-number v-model="edi_num" :step="1" :min="1" :max="maxAttendNum" style="width:20%"></el-input-number>
        </div>
        <div v-if="isCare" style="display:flex;align-items:center;margin-top:10px;">
          <p style="width:120px">同行人关怀</p>
          <el-select v-model="edi_tx" ref='select13' multiple
                     filterable placeholder="全部标签"
                     style="width:20%;">
            <el-option
              v-for="item in liTx"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div style="display:flex;align-items:center;margin-top:10px;">
          <p style="width:120px">客户手机号</p>
          <el-input v-model="edi_phone" :step="1" style="width:20%"></el-input>
        </div>
        <div style="display:flex;width:60%;margin-top:10px;">
          <el-button style="margin-right:1px;height:40px;width:120px" type="primary"
                     @click="onKeep">提交
          </el-button>
          <el-button @click="onBack()" style="height:40px;width:120px">取消
          </el-button>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import axios from 'axios';
import moment from "moment/moment";

export default {
  name:"resvGlAdd",
  data(){
    return {
      h_text:"新增预约",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""},
        {"text":"预约设置","colour":"#B7B7B7","pages":""}
      ],
      id:0,
      isCtr:true,
      isCare:false, /*是否需要填写人文关怀*/
      isAttendNum:false, /*是否需要填写参与人数*/
      maxAttendNum:10,/*预约最多填写人数*/
      edi_num:1,
      edi_name:"代客预约",
      edi_phone:"",
      edi_day:new Date(),
      edi_room:"",
      li_room:[],
      edi_tx:"", /*同行人员标签*/
      liTx:[], /*同行人员标签*/
      name:"空间预约（代客预约）",
      page:1,
      pageSize:10,
      total:0,
      startTime:"09:00",
      endTime:"18:00"
    };
  },
  computed:{},
  methods:{ /*方法存放*/
    handleSelectMenu(path){ /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    onKeep(){
      if(!(this.startTime || this.endTime)) {
        this.$message.info('请先选择起始/结束时间');
        return;
      }
      if(this.isCtr) {
        this.isCtr = false;
        this.changeNotice();
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    changeNotice(){
      const params = {
        name:this.edi_name,
        roomId:this.edi_room,
        beginExpDate:`${moment(this.edi_day,'MM-DD-YYYY').format('YYYY-MM-DD')} ${this.startTime}:00`,
        endExpDate:`${moment(this.edi_day,'MM-DD-YYYY').format('YYYY-MM-DD')} ${this.endTime}:00`,
        customNumber:this.edi_phone,
        projectId:localStorage.getItem("projectId")
      };
      if(this.isAttendNum) { /*人数*/
        params["number"] = this.edi_num;
      }
      if(this.isCare) {
        let l_d = [];
        for(let i = 0; i < this.edi_tx.length; i++) {
          l_d.push({
            "id":this.edi_tx[i]
          });
        }
        params["cares"] = l_d;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.addAppointBySys,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("添加失败");
        }
      });
    },
    onBack(){
      if(this.isCtr) {
        this.isCtr = false;
        this.$router.go(-1);
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    parseToInt(li_str){ /*字符串转分钟*/
      if(li_str) {
        const arr = li_str.split(":");
        if(arr.length === 2) {
          const h = parseInt(arr[0]);
          const m = parseInt(arr[1]);
          return h * 60 + m;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    parseToTime(val){ /*数字转时间*/
      if(val) {
        let h = `${parseInt(val / 60)}`.toString().padStart(2,'0') + ":";
        let m = `${parseInt(val % 60)}`.toString().padStart(2,'0');
        return h + m;
      } else {
        return "00:00";
      }
    },
    timestampToTime(timestamp){/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return Y + M + D + h + m + s;
    },
    getRoomList(){
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getRoomList,params,headers).then(res => {
        console.log("getRoomList：",res.data.data);
        this.liRoom = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    init_View(){
      let li_d = [];
      for(let i = 0; i < this.liRoom.length; i++) {
        const d = {
          "label":this.liRoom[i]["name"],
          "value":this.liRoom[i]["id"],
          "isCare":this.liRoom[i]["isCare"],
          "isAttendNum":this.liRoom[i]["isAttendNum"],
          "maxAttendNum":this.liRoom[i]["maxAttendNum"]
        };
        li_d.push(d);
      }
      this.li_room = li_d;
      console.log("li_room",this.li_room);
      if(this.liRoom.length > 0) {
        this.edi_room = this.liRoom[0]["id"];
        this.init_room(this.liRoom[0]);
      }
    },
    init_room(d){
      console.log("d",d);
      this.isCare = d.isCare;
      this.isAttendNum = d.isAttendNum;
      this.maxAttendNum = d.maxAttendNum;
    },
    change_room(){
      const foundItem = this.liRoom.find(item => item.id === this.edi_room);
      this.init_room(foundItem);
    },
    getAppointCareList(){
      const params = {
        "page":1,
        "pageSize":30,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getAppointCareList,params,headers).then(res => {
        console.log("getInfo:",res.data.data);
        let l_d = res.data.data.list;
        if(l_d && l_d.length > 0) { /*同行*/
          const l = [];
          for(let i = 0; i < l_d.length; i++) {
            l.push({value:l_d[i]['id'],label:l_d[i]['name']});
          }
          this.liTx = l;
        } else {
          this.liTx = [];
        }
      });
    }
  },
  mounted(){ /*页面加载时调用*/
    this.getAppointCareList();
    this.getRoomList();
  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>
#resvGlAdd {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/resvGlAdd.vue